import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import store, { SET_AREA } from 'store';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import { PublicRoutes, PrivateRoutes } from './routes';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from 'helpers/PrivateRoute';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './style.scss';
import './app.scss';

import history from './history';
import Params from 'helpers/Params';
import LoginService from 'services/login';
import Loading from './Loading';

const Routes = connect(
  state => ({
    isLogged: state.user.authenticate,
    pathname: state.router.location.pathname,
    isLoading: state.loading,
    area: state.area
  }),
  dispatch => ({
    setArea: payload => dispatch({ type: SET_AREA, payload })
  })
)(() => {

  return (
    <>
      <ToastContainer />

      {/* { isLoading ? <Loading /> : null } */}

      {PublicRoutes.map((route, k) => (
        <Route
          key={k}
          exact={!!route.exact}
          path={route.pathname}
          component={route.component}
          {...route.props}
        />
      ))}

      {PrivateRoutes.map((route, k) => {
        return (
          <PrivateRoute
            isLogged={localStorage.getItem('user') ? true : false}
            key={k}
            exact={!!route.exact}
            path={route.pathname}
            component={route.component}
            {...route.props}
            permission={route.permission}
          />
        );
      })}
    </>
  );
});

const App = () => {
  const [autoLogin,setAutoLogin] = useState(false);
  useEffect(()=>{
    async function c(){
      if(Params.get('t-al')) {
        setAutoLogin(true);
        let response = await LoginService.autoLogin(Params.get('t-al'));
        let info = response.data;
  
        info = info.data;
        
        localStorage.setItem('token', info.access_token);
        localStorage.setItem('username', info.user.name);
        localStorage.setItem('profile', info.user.profiles[0].name);
        localStorage.setItem('routes', JSON.stringify(info.user.profiles[0].routes));
        
        setAutoLogin(false);
        window.location.href = window.location.href.split('?')[0];
      }
    }
    c();
  },[])

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        {/* <Redirect from='/' to='/sumo/quote-request' /> */}
        <Switch>
          {autoLogin?<Loading />:<Routes />}
        </Switch>
      </ConnectedRouter>
    </Provider>
  );
};

export default App;
